import {ParserType} from "./ParserType";
import {OplusParser} from "./parsers/OplusParser";
import {RufusParser} from "./parsers/RufusParser";
import {OphtixParser} from "./parsers/OphtixParser";

export class ParserManager {
    constructor() {
        this.parsers = {
            [ParserType.OPLUS]: new OplusParser(),
            [ParserType.RUFUS]: new RufusParser(),
            [ParserType.OPHTIX]: new OphtixParser()
        }
    }

    async parseFile(file, parserType) {
        const parser = this.parsers[parserType];
        if (!parser) {
            throw new Error(`Parser type ${parserType} is not supported.`);
        }
        return await parser.parseFile(file);
    }

    parseData(text, parserType) {
        const parser = this.parsers[parserType];
        if (!parser) {
            throw new Error(`Parser type ${parserType} is not supported.`);
        }
        return parser.parseData(text);
    }
}